import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-mirror-value]';
const PLUGIN_NAME = 'MirrorValue';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--mirror-value" */ './mirror-value'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/mirror-value/plugin--split.js